var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFlagGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.4 2 9 0H0v17h2v-7h5.6l.4 2h7V2H9.4Zm3.6 8H9.64l-.4-2H2V2h5.36l.4 2H13v6Z",
  fill: "#002B2B"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "gray",
    fillRule: "evenodd",
    strokeWidth: 0.0150977
  },
  d: "M9.66 9.987c-.002-.004-.095-.456-.206-1.004l-.202-.996-3.614-.008-3.615-.008V2.023l2.664.007 2.663.008.197.99.197.988h5.24v5.979h-1.66c-.914 0-1.663-.004-1.665-.008z"
}));

export { SvgFlagGray as ReactComponent };
export default __webpack_public_path__ + "cb5894908f8fdcc54d5d94bed8c3b7c9.svg";